export const PAYMENT_METHOD_TOGGLE_OPTIONS = [
  { key: "COD", label: "Cash On Delivery" },
  { key: "APPLE", label: "Apple Pay" },
  { key: "CARD", label: "Card" },
  { key: "CARD_ON_DELIVERY", label: "Card On Delivery" },
  { key: "MOKAFAA", label: "MOKAFAA" },
  { key: "LOYALTY_POINTS", label: "LOYALTY POINTS" },
  { key: "WALLET", label: "WALLET" },
  { key: "PAYTABS", label: "PAYTABS" },
  { key: "FULL_DISCOUNT_OR_REWARDS", label: "FULL DISCOUNT OR REWARDS" },
  { key: "FULL_DISCOUNT", label: "FULL DISCOUNT" },
]

/** DB codes → i18n keys (same mapping as brand details). */
export const PAYMENT_METHOD_LABELS = {
  COD: "Cash On Delivery",
  APPLE: "Apple Pay",
  CARD: "Card",
  CARD_ON_DELIVERY: "Card On Delivery",
  MOKAFAA: "Mokafaa Points",
  ALRAJHI_BANK: "Mokafaa Points",
  LOYALTY_POINTS: "Loyalty Points",
  LOYALTY_REWARDS: "Loyalty Points",
  WALLET: "WALLET",
  PAYTABS: "PAYTABS",
  FULL_DISCOUNT_OR_REWARDS: "FULL DISCOUNT OR REWARDS",
  FULL_DISCOUNT: "Full Discount",
}

export const formatPaymentMethodLabels = (methods, t) => {
  if (!Array.isArray(methods) || methods.length === 0) {
    return null
  }
  return methods
    .map(method => t(PAYMENT_METHOD_LABELS[method] || method))
    .join(", ")
}

export const defaultPaymentMethodValues = PAYMENT_METHOD_TOGGLE_OPTIONS.reduce(
  (acc, option) => {
    acc[option.key] = false
    return acc
  },
  {}
)

/**
 * Report / order filter values → system-setting keys from brand allowed methods.
 * Partial options are shown when any related brand-allowed method is present.
 */
export const REPORT_PAYMENT_METHOD_TO_SETTINGS_KEYS = {
  COD: ["COD"],
  CARD: ["CARD"],
  CARD_ON_DELIVERY: ["CARD_ON_DELIVERY"],
  APPLE: ["APPLE"],
  ALRAJHI_BANK: ["MOKAFAA"],
  LOYALTY_REWARDS: ["LOYALTY_POINTS"],
  FULL_DISCOUNT: ["FULL_DISCOUNT"],
  FULL_DISCOUNT_OR_REWARDS: ["FULL_DISCOUNT_OR_REWARDS"],
  "Partial-Card/Apple": ["CARD", "APPLE"],
  "Partial-Wallet": ["WALLET"],
  "Partial-Reward": ["LOYALTY_POINTS"],
  "Partial-Discount": ["FULL_DISCOUNT"],
}

/** Union of brand-allowed settings keys across tenant payment-method scope cards. */
export const collectTenantAllowedSettingsKeys = (scopeCards = []) => {
  const keys = new Set()
  ;(scopeCards || []).forEach(card => {
    ;(card.allowedMethods || []).forEach(key => {
      if (key) keys.add(String(key))
    })
  })
  return keys
}

/**
 * Keep only report payment-method options granted by the tenant's assigned brands.
 * @param {Array<{label: string, value: string}>} paymentMethodTypes
 * @param {Array} scopeCards - from getPaymentMethodsScope
 */
export const filterPaymentMethodTypesByTenantScope = (
  paymentMethodTypes = [],
  scopeCards = []
) => {
  const allowed = collectTenantAllowedSettingsKeys(scopeCards)
  if (allowed.size === 0) {
    return []
  }

  return (paymentMethodTypes || []).filter(item => {
    const requiredKeys =
      REPORT_PAYMENT_METHOD_TO_SETTINGS_KEYS[item?.value] || []
    return requiredKeys.some(key => allowed.has(key))
  })
}
